// extracted by mini-css-extract-plugin
export default {"card":"thankyou_card__iKWTR","successCircle":"thankyou_successCircle__Osnx5","copy":"thankyou_copy__eNcrE","support":"thankyou_support__yjlxI"};